import { z } from "zod";
import { WorkItemSchema } from "../workflows/types";

export const WorkItemListResponseSchema = z.object({
    items: z.array(WorkItemSchema),
    totalCount: z.number(),
    includeCompleted: z.boolean(),
    skip: z.number(),
    take: z.number(),
    // Server time the total was read at (ISO 8601). Present on /workitems/mine;
    // the taskbar badge orders its writes by it. Absent or null elsewhere.
    asOf: z.string().nullish(),
});

export type WorkItemListResponse = z.infer<typeof WorkItemListResponseSchema>;
